export const REGEX = {
  ACCOUNT_NUMBER: /^[0-9]{7,}$/,
  PHONE_NUMBER: /^(\+[1-9]{1}[0-9]{1,14}|08[1-9]{2}[0-9]{6,9})$/,
  PASSWORD: /^(?=.{8,})(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&~]).*$/,
  NAME: /^[a-z][a-z0-9]+$/,
  COMPANY_NAME: /^[a-zA-Z0-9 ()&.,!#_@-]+$/,
  KTP_NUMBER: /^[0-9]{16}$/,
  POSTAL_CODE: /^[0-9]{5}$/,
  BIRTH_PLACE_AND_DATE: /^[A-Za-z]+, \d{2}\d{2}\d{4}$/,
  BUSINESS_LINK:
    /(?:https?:\\\\)?(?:www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-z]{2,63}\\b([-a-zA-Z0-9@:%_\\+.~#?&/=]*)/i,
  HTTPS:
    /https:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_+.~#?&//=]*)/,
  PHONE_NUMBER_WITH_62: /\(?(?:62)(?:\d{2,3})?\)?\d{2,4}?\d{2,4}?\d{2,4}/,
  ALPHANUMERIC_WITH_SPACES: /^[a-zA-Z0-9 ]+$/,
};
